import React, { useContext, useEffect, useRef, useState } from 'react';
import { SheetContext } from '../providers/SheetContext';
import UploadMediaModal from './upload/UploadMediaModal';
import MediaLibrary from './MediaLibrary';
// Import Polaris web component types
import '../../types/polaris-web-components.d';

export const Sheet = () => {
  const { sheet, hide } = useContext(SheetContext);
  const sheetRef = useRef<HTMLDivElement>(null);
  const [uploadOpen, setUploadOpen] = useState(false);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (sheet.visible && sheetRef.current && !sheetRef.current.contains(event.target as Node)) {
        hide();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [sheet.visible, hide]);

  // Close on escape
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (sheet.visible && event.key === 'Escape') {
        hide();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [sheet.visible, hide]);

  // Lock body scroll while the sheet is open
  useEffect(() => {
    if (!sheet.visible) return;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [sheet.visible]);

  return (
    <React.Fragment>
      {uploadOpen && <UploadMediaModal visible onClose={() => setUploadOpen(false)} />}
      {sheet.visible && (
        <div className='mls-overlay'>
          <div
            ref={sheetRef}
            className='mls-panel'
            role='dialog'
            aria-modal='true'
            aria-label='Media library'
          >
            {/* Header */}
            <div className='mls-header'>
              <s-heading>Media library</s-heading>
              <div className='mls-header__actions'>
                <s-button
                  variant='primary'
                  icon='plus'
                  onClick={() => {
                    hide();
                    setUploadOpen(true);
                  }}
                >
                  Upload
                </s-button>
                <s-button variant='tertiary' icon='x' accessibilityLabel='Close' onClick={hide} />
              </div>
            </div>

            <MediaLibrary
              active={sheet.visible}
              onRequestUpload={() => {
                hide();
                setUploadOpen(true);
              }}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Sheet;
